import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

const DOCUMENT_TITLE = 'Seenic Dashboard - Tours & 3DExplorers Analytics';

const Page = forwardRef(({ children, ...rest }, ref) => {
  return (
    <div ref={ref} {...rest}>
      <Helmet>
        <title>{DOCUMENT_TITLE}</title>
      </Helmet>
      {children}
    </div>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Page;
